var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.nodeName || '').length > 0)?_c('router-link',{staticClass:"d-block kk-hoverable-image",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }